import lunr from "/opt/buildhome/repo/node_modules/.pnpm/lunr@2.3.9/node_modules/lunr/lunr.js";
require("/opt/buildhome/repo/node_modules/.pnpm/lunr-languages@1.22.0/node_modules/lunr-languages/lunr.stemmer.support.js")(lunr);
require("/opt/buildhome/repo/node_modules/.pnpm/lunr-languages@1.22.0/node_modules/lunr-languages/lunr.pt.js")(lunr);
export const removeDefaultStopWordFilter = [];
export const language = ["pt"];
export const searchIndexUrl = "search-index{dir}.json";
export const searchResultLimits = 8;
export const fuzzyMatchingDistance = 1;